var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEducation = function SvgEducation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 168.72 168.72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.29,91.54V108.7a12.27,12.27,0,0,0,6.35,10.74l30.52,16.67a12.16,12.16,0,0,0,11.73,0l30.52-16.67a12.27,12.27,0,0,0,6.35-10.74V91.54L86.89,111.69a12.16,12.16,0,0,1-11.73,0Zm36.87-59L23.7,60.65a6.14,6.14,0,0,0,0,10.74L75.16,99.48a12.16,12.16,0,0,0,11.73,0L136,72.68v36.08a6.11,6.11,0,0,0,12.21,0V69.62A6.14,6.14,0,0,0,145,64.25L86.89,32.57A12.44,12.44,0,0,0,75.16,32.57Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education.7ed708ef.svg";
export { ForwardRef as ReactComponent };